import React from "react";
import { Isvg } from "../../../../components";
import { VstButton, VstDropdown } from "vstui";
import Template from "../template";
import Confidences from "./confidences";

const PreviewPresentation = ({
  cancel,
  deck,
  destroy,
  disabled,
  duplicate,
  edit,
  editing,
  isbn,
  onClick,
  study,
  testDup
}) => {
  if (editing) {
    return (
      <Template
        cancel={cancel}
        isbn={isbn}
        title={deck.title}
        uuid={deck.uuid}
        editing={editing}
      />
    );
  }

  const _mobileEditButton = () => {
    let touchDevice = "none";
    if (Fraction.Helpers.Browser.isNewTouchDevice()) {
      touchDevice = "block";
    }
    return (
      <VstButton
        id="mobile-edit-button"
        className="noButton"
        title={i18n.t("reader.flashcards.edit")}
        style={{ display: touchDevice }}
      >
        <Isvg src="/img/ellipsis.svg" />
        <span className="offScreen">{i18n.t("reader.flashcards.edit")}</span>
      </VstButton>
    );
  };

  const showDeleteModal = () => {
    const content = (
      <div>
        <h2>{i18n.t("reader.flashcards.delete-modal.are-you-sure")}</h2>
        <p>
          {i18n.t("reader.flashcards.delete-modal.will-be-permanent", {
            title: deck.title
          })}
        </p>
        <div id="bottom-buttons">
          <VstButton
            className="cancel"
            onClick={Fraction.Helpers.removeVSTModal}
            options="btn-32"
          >
            {i18n.t("base.cancel")}
          </VstButton>
          <VstButton
            className="delete"
            disabled={disabled}
            onClick={destroy}
            options="btn-32"
          >
            {i18n.t("base.delete")}
          </VstButton>
        </div>
      </div>
    );
    Fraction.Helpers.showVSTModal({
      content: content,
      definingClass: "flashcards",
      modalContainerHeader: false,
      modalDimensions: "smallModal"
    });
  };

  const card_count = deck.card_count || (deck.cards && deck.cards.length);
  const mobileHideButtons = Fraction.Helpers.Browser.isNewTouchDevice()
    ? "none"
    : "block";

  return (
    <div id={`deck-${deck.uuid}`} className={`deck ${testDup ? "slide" : ""}`}>
      <div className="deck-top-container">
        <VstButton
          className={"show-on-hover trash no-button"}
          style={{ display: mobileHideButtons }}
          title={i18n.t("reader.flashcards.delete")}
          onClick={showDeleteModal}
        >
          <span className="offScreen">
            {i18n.t("reader.flashcards.delete")}
          </span>
        </VstButton>
        <VstButton
          className="show-on-hover duplicate no-button"
          disabled={disabled}
          onClick={duplicate}
          title={i18n.t("reader.flashcards.duplicate")}
          style={{ display: mobileHideButtons }}
        >
          <span className="offScreen">
            {i18n.t("reader.flashcards.duplicate")}
          </span>
        </VstButton>
        <VstButton
          id={`edit-${deck.uuid}`}
          className="show-on-hover edit no-button"
          disabled={disabled}
          onClick={edit}
          title={i18n.t("reader.flashcards.edit")}
          style={{ display: mobileHideButtons }}
        >
          <span className="offScreen">{i18n.t("reader.flashcards.edit")}</span>
        </VstButton>
        <VstDropdown
          horizontal="right"
          className="edit-dropdown"
          target={_mobileEditButton()}
          headerTitle={i18n.t("reader.panels.figures")}
        >
          <VstDropdown.Item className={""} onClick={study}>
            {i18n.t("reader.flashcards.study")}
          </VstDropdown.Item>
          <VstDropdown.Item className={""} closeOnClick={false} onClick={edit}>
            {i18n.t("reader.flashcards.edit")}
          </VstDropdown.Item>
          <VstDropdown.Item className={""} onClick={duplicate}>
            {i18n.t("reader.flashcards.duplicate")}
          </VstDropdown.Item>
          <VstDropdown.Item className={""} onClick={showDeleteModal}>
            {i18n.t("reader.flashcards.delete")}
          </VstDropdown.Item>
        </VstDropdown>
        {card_count > 0 && (
          <VstButton
            className={"show-on-hover play no-button"}
            onClick={study}
            title={i18n.t("reader.flashcards.play")}
            style={{ display: mobileHideButtons }}
          >
            <span className="offScreen">
              {i18n.t("reader.flashcards.play")}
            </span>
          </VstButton>
        )}
      </div>
      <div className="deck-bottom-container">
        <VstButton
          className="title-card no-button"
          onClick={() => onClick(deck)}
        >
          <div className="title">{deck.title}</div>
          {card_count ? (
            <div className="card-count">
              {i18n.pluralize(
                card_count,
                "reader.flashcards.one-card",
                "reader.flashcards.card-count"
              )}
            </div>
          ) : (
            <div
              id={`add-cards-${deck.uuid}`}
              className="add-cards"
            >
              {i18n.t("reader.flashcards.add-cards")}
            </div>
          )}
        </VstButton>
      </div>
      {card_count > 0 && (
        <Confidences
          deckUuid={deck.uuid}
          unrated={card_count - deck.proficiencies.length}
          confidences={deck.proficiencies}
        />
      )}
    </div>
  );
};

export default PreviewPresentation;
